import { render, staticRenderFns } from "./PVIReports.vue?vue&type=template&id=660f3cf0&"
import script from "./PVIReports.vue?vue&type=script&lang=js&"
export * from "./PVIReports.vue?vue&type=script&lang=js&"
import style0 from "./PVIReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/PVIReports.vue
// module id = null
// module chunks = 